import { GamesProviderState } from "./GamesProvider.types";
import { createContext } from "react";

export const GamesProviderContext = createContext<GamesProviderState | undefined>(undefined);